var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpentoggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 24,
    height: 24,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_615",
    "data-name": "Mask Group 615",
    transform: "translate(24 24) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(6 8.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M.448,7.579a.543.543,0,0,0,.5-.5L1.317.448A.415.415,0,0,0,.87,0a.543.543,0,0,0-.5.5L0,7.132A.415.415,0,0,0,.448,7.579Z",
    transform: "translate(5.36 0) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M.87,7.579a.415.415,0,0,0,.447-.447L.948.5a.543.543,0,0,0-.5-.5A.415.415,0,0,0,0,.448L.37,7.079A.543.543,0,0,0,.87,7.579Z",
    transform: "translate(4.95 0.933) rotate(-45)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpentoggle);
export default __webpack_public_path__ + "static/media/icon_opentoggle.4ed22aabba32abf4b336fcb04bc3d58d.svg";
export { ForwardRef as ReactComponent };